import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">

      <h3>CK Lunch Box</h3>

      <p>Fresh Homemade Meals Delivered Daily</p>

      <div className="footer-details">
        <p>📞 9515971814</p>
        <p>📍 Hyderabad</p>
      </div>

      <p className="copyright">
        © 2026 CK Lunch Box. All Rights Reserved.
      </p>

    </footer>
  );
}

export default Footer;